import { Link } from "react-router-dom";
import { ArrowUpRight, MoveRight } from "lucide-react";
import { kitchens } from "@/kitchens";

const categories = [
  { index: "01", title: "Modular kitchens", desc: "The heart of your home, composed with precision.", image: "https://customer-assets-0z36b82j.emergentagent.net/job_modular-excellence/artifacts/0h3t1jhk_IMG_6694.jpg", path: "/kitchens" },
  { index: "02", title: "Personalized wardrobes", desc: "Quiet luxury, with a place for everything.", image: "https://customer-assets-0z36b82j.emergentagent.net/job_modular-excellence/artifacts/0l890qyu_IMG_6746.jpg", path: "/wardrobes" },
  { index: "03", title: "TV units", desc: "A considered frame for your everyday rituals.", image: "https://customer-assets-0z36b82j.emergentagent.net/job_modular-excellence/artifacts/a07riemr_IMG_6795.jpg", path: "/tv-units" },
  { index: "04", title: "Storage", desc: "Everything in its place, beautifully concealed.", image: "https://customer-assets-0z36b82j.emergentagent.net/job_modular-excellence/artifacts/08pcudip_IMG_6806.JPG", path: "/storage" },
];

export function ProductsPage() {
  return (
    <div data-testid="products-page">
      <section className="page-hero">
        <div className="page-hero-copy">
          <span className="eyebrow">The collection</span>
          <h1>One studio.<br /><i>Every space considered.</i></h1>
          <p>From raw board to finished masterpiece, every piece is born in our Vasai factory — cut by German precision machines, shaped by patient hands, and finished to be lived with for generations. Kitchens, wardrobes, TV units and storage: furniture manufactured not for seasons, but for lifetimes.</p>
          <Link to="/contact" className="button" data-testid="page-primary-cta">Start a conversation <MoveRight size={17} /></Link>
        </div>
        <img className="page-hero-portrait" src="https://customer-assets-0z36b82j.emergentagent.net/job_modular-excellence/artifacts/4t09l0v1_IMG_6820.jpg" alt="Night-time luxury kitchen with long island and garden view by Innovation Modular System" />
      </section>
      <section className="content-section">
        <div>
          <span className="eyebrow">Explore by space</span>
          <h2>Four collections.<br /><i>One standard of craft.</i></h2>
          <div className="product-grid">
            {categories.map((c) => (
              <Link to={c.path} className="product-card" key={c.title} data-testid={`category-card-${c.index}`}>
                <div className="card-image"><img src={c.image} alt={c.title} /><span>{c.index}</span></div>
                <div className="card-copy"><h3>{c.title}</h3><p>{c.desc}</p><ArrowUpRight size={20} /></div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export function KitchensPage() {
  return (
    <div data-testid="kitchens-page">
      <section className="page-hero">
        <div className="page-hero-copy">
          <span className="eyebrow">Modular kitchens</span>
          <h1>Kitchens with<br /><i>a point of view.</i></h1>
          <p>A modular kitchen is more than a room. It is the stage for your mornings, your gatherings, your life. Our European-inspired systems bring considered form and flawless function together.</p>
          <Link to="/contact" className="button" data-testid="page-primary-cta">Start a conversation <MoveRight size={17} /></Link>
        </div>
        <img className="page-hero-portrait" src="https://customer-assets-0z36b82j.emergentagent.net/job_modular-excellence/artifacts/ryid4m5r_IMG_6774.jpg" alt="Dark luxury kitchen and dining space with statement chandelier by Innovation Modular System" />
      </section>
      <section className="content-section">
        <div>
          <span className="eyebrow">The kitchen edit</span>
          <h2>Seven signatures.<br /><i>Infinite possibilities.</i></h2>
          <div className="series-grid">
            {kitchens.map((k) => (
              <Link to={`/kitchens/${k.slug}`} className="series-card" key={k.slug} data-testid={`series-card-${k.index}`}>
                <img src={k.image} alt={k.alt} />
                <div>
                  <span>{k.index} / 07</span>
                  <h3>{k.name}</h3>
                  <p>{k.finish} · {k.layout}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
